import api from "axios";

export function getParticipantFlags(flag = '') {
  if (flag.length > 0) {
    flag = '/' + flag;
  }
  return api
    .get("/purchasers/flagsParticipant" + flag)
    .then((response) => response.data.payload.data);
}
